import { CloseCircleOutlined, SearchOutlined, UserAddOutlined } from "@ant-design/icons";
import { Button, Input, Row, Space } from "antd";
import React, { useEffect, useState } from "react";
import { useBoolean, useDebounce } from "usehooks-ts";
import AddNewMemberModal from "../AddNewMemberModal/AddNewMemberModal";
import { useMemberManagerToolbarStyles } from "./styles";

/**
 * The user management toolbar
 */
export const UserManagementToolbar = ({ onSearch }) => {
  const [query, setQuery] = useState(null);
  const debouncedQuery = useDebounce(query, 500);
  const { value: modalVisible, setTrue: showModal, setFalse: hideModal } = useBoolean();

  useEffect(() => {
    if (debouncedQuery !== null) {
      onSearch(debouncedQuery);
    }
  }, [debouncedQuery]);

  const { menuBarCls } = useMemberManagerToolbarStyles();

  return (
    <Row className={menuBarCls} justify="space-between">
      <Space>
        <Button icon={<UserAddOutlined />} type="link" onClick={showModal}>
          Add users
        </Button>
      </Space>
      <Space>
        {query && (
          <CloseCircleOutlined
            onClick={() => {
              setQuery("");
            }}
          />
        )}
        <Input
          prefix={<SearchOutlined />}
          placeholder="Search users"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </Space>
      <AddNewMemberModal visible={modalVisible} onCancel={hideModal} />
    </Row>
  );
};
